// Browser back, with a home fallback when there's no history to pop (direct
// load / new tab) so a "back" action never dead-ends.
export function navigateBack(webFallback) {
  if (typeof window === "undefined") {
    return;
  }
  if (window.history.length > 1) {
    window.history.back();
    return;
  }
  window.location.href = webFallback || "/";
}
